import React from 'react';
import { useGetProjectsQuery } from '../../features/projects/projectsApi';
import { useGetTeamQuery } from '../../features/team/teamApi';
import Project from './Project';
import Team from './Team';

function Sidebar() {
  //Variables
  const { data: teamData, isLoading: teamIsLoading, isError: teamIsError, isSuccess: teamIsSuccess } = useGetTeamQuery();
  const { data: projectsData, isLoading: projectsIsLoading, isError: projectsIsError, isSuccess: projectsIsSuccess } = useGetProjectsQuery();
  const teamMembers = teamData || [];
  const projects = projectsData || [];

  //JSX
  return (
    <div className="sidebar">
      <div>
        <h3 className="text-xl font-bold">Projects</h3>
        <div className="mt-3 space-y-4">
          {projects.map(project => (<Project key={project.id} project={project} />))}

        </div>
      </div>
      <div className="mt-8">
        <h3 className="text-xl font-bold">Team Members</h3>
        <div className="mt-3 space-y-4">
          {teamMembers.map(member => (<Team key={member.id} member={member} />))}
        </div>
      </div>
    </div>
  )
}

export default Sidebar;
